module.exports = __webpack_public_path__ + "static/form-33d405ac12be5ab65fc4e024e47919db.png";